/**
 * 重定向路由
 */
export const redirectPaths = {
  // 后期随权限需求一起开发
};

export default Object.entries(redirectPaths).map((item) => ({
  path: item[0],
  redirect: item[1]
}));
